var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowLeft = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "ArrowLeft",
  x: "0px",
  y: "0px",
  viewBox: "0 0 24 114",
  style: {
    enableBackground: "new 0 0 24 114"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.stal0{stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st1al{fill:#63C36C;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "st0al",
  d: "M1.5,112.5c18.2-1.7,21-11.3,21-11.3V80.7l-7.8-23.1l7.8-24.3V12.9c0,0-5.3-10.1-21-11.3v54.9v57.3"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "st1al",
  d: "M4.7,108.6c16.9-0.8,15.1-10,15.1-10l1.4-18L10.3,57.2l10.9-24l-1.4-17.6c0,0-3.1-9.7-15.1-10l1.4,51.7"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  className: "st0al",
  d: "M-84.5,44.1"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ArrowLeft.c36c4763.svg";
export { ForwardRef as ReactComponent };